/**
 * Creates title string from searchTerm + categoryName; Or if categoryResultPage, from single active brand in filterBrands + categoryName
 * @param {bool} categoryResultPage
 * @param {string} searchTerm
 * @param {string} categoryName
 * @param {{selectedValues: string[], options: {value : string, name : string}[]}} filterBrands
 * @returns {string}
 */
export const generateH1 = (
    categoryResultPage,
    searchTerm,
    categoryName,
    filterBrands
) => {
    const {
        selectedValues: selectedBrands = [],
        options: allBrands
    } = filterBrands;
    const singleBrand = allBrands
        ? allBrands.find(b => b.value === selectedBrands[0])
        : '';
    const selectedBrand =
        selectedBrands.length == 1 ? `${singleBrand.name + ' '}` : '';
    const activeCategory = categoryName ? categoryName : 'Alla kategorier';

    return categoryResultPage
        ? `${selectedBrand + activeCategory}`
        : `${
              searchTerm ? '"' + searchTerm + '"' + ' i ' + activeCategory : ''
          }`;
};



// WEBPACK FOOTER //
// ./src/EbaySweden.TouchWeb/static/script/components/search-results/header/header.js